import React, { useEffect } from "react";
import "./Fourth.css";
import gsap from "gsap";
import { ReactComponent as NavMain } from "./SVG/main.svg";
import { ReactComponent as NavArrow } from "./SVG/arrow.svg";
import { ReactComponent as NavSignz } from "./SVG/signz.svg";
import { ReactComponent as NavCareers } from "./SVG/career.svg";
import { ReactComponent as NavTeam } from "./SVG/team.svg";
import { ReactComponent as NavCompany } from "./SVG/company.svg";
import { ReactComponent as NavOptions } from "./SVG/options.svg";
import TeamData from "../Components/TeamData";
import CompanyData from "../Components/CompanyData";
import SignzData from "../Components/SignzData";
import CareersData from "../Components/CareersData";

function Fourth() {
  var current = null;
  var listening = true;
  let arrow = null;
  let navarray = null;
  let optionarray = null;
  let rotationDeg = null;
  let backgroundcolor = null;
  let buttonsid = null;
  let optiontextids = null;
  function setupFourth() {
    navarray = [
      document.getElementById("navcareers"),
      document.getElementById("navcompany"),
      document.getElementById("navteam"),
      document.getElementById("navsignz"),
    ];
    optionarray = [
      document.getElementById("careersdata"),
      document.getElementById("companydata"),
      document.getElementById("teamdata"),
      document.getElementById("signzdata"),
    ];
    rotationDeg = [180, 270, 0, 90];
    backgroundcolor = ["#010812", "#111e2e", "#1a221b", "#101614"];
    buttonsid = [
      document.getElementById("stt0-1"),
      document.getElementById("stt0-2"),
      document.getElementById("stt0-3"),
      document.getElementById("stt0-4"),
    ];
    optiontextids = [
      document.getElementById("optionstext-1"),
      document.getElementById("optionstext-2"),
      document.getElementById("optionstext-3"),
      document.getElementById("optionstext-4"),
    ];

    current = 3;
    arrow = document.getElementById("navarrow");
    document.getElementById("stt0-1").addEventListener("click", () => {
      optionChange(1);
      //careers
    });
    document.getElementById("stt0-2").addEventListener("click", () => {
      optionChange(2);
      //company
    });
    document.getElementById("stt0-3").addEventListener("click", () => {
      optionChange(3);
      //team
    });
    document.getElementById("stt0-4").addEventListener("click", () => {
      optionChange(4);
      //signz
    });
  }

  function optionChange(next) {
    if (!listening) {
      //do nothing
    } else {
      listening = false;
      optionarray[next - 1].style.zIndex = 1;
      let tl = gsap.timeline({
        onComplete: () => {
          optionarray[current - 1].style.zIndex = -1;
          optiontextids[next - 1].style.fill = "#fff";
          optiontextids[current - 1].style.fill = "#000";
          buttonsid[next - 1].style.filter = "drop-shadow(0px 0px 10px #fff)";
          buttonsid[current - 1].style.filter =
            "drop-shadow(0px 0px 10px #070500)";
          buttonsid[next - 1].style.stroke = "#fff";
          buttonsid[current - 1].style.stroke = "#BF9830";
          current = next;
          listening = true;
        },
      });
      let entry = null;
      let exit = null;
      if (
        (rotationDeg[next - 1] - rotationDeg[current - 1] + 360) % 360 <
        180
      ) {
        //clockwise
        entry = "315_short";
        exit = "45_short";
      } else {
        entry = "45_short";
        exit = "315_short";
        // anti-clockwise
      }

      tl.to(arrow, { duration: 1, rotation: rotationDeg[next - 1] + "_short" });
      tl.to(
        document.getElementById("fourthbg"),
        {
          background: backgroundcolor[next - 1],
          duration: 1,
        },
        "<"
      );
      tl.to(
        navarray[current - 1],
        { duration: 0.5, opacity: 0, height: "80px", ease: "Power4.easeOut" },
        "<"
      );
      tl.fromTo(
        optionarray[current - 1],
        { opacity: 1, rotation: "0_short" },
        {
          opacity: 0,
          duration: 0.5,
          rotation: exit,
          ease: "Power4.easeOut",
        },

        "<"
      );
      tl.to(
        navarray[next - 1],
        { duration: 0.5, opacity: 1, height: "170px", ease: "Power4.easeOut" },
        ">"
      );
      tl.fromTo(
        optionarray[next - 1],
        { opacity: 0, rotation: entry },
        {
          opacity: 1,
          duration: 0.5,
          rotation: "0_short",
          ease: "Power4.easeOut",
        },
        "<"
      );
      tl.play();
    }
  }
  useEffect(() => {
    setupFourth();
  }, []);
  return (
    <section className="fourth">
      <div className="outer">
        <div className="inner">
          <div className="bg" id="fourthbg">
            <NavMain className="nav-main" />
            <NavArrow id="navarrow" className="nav-arrow" />
            <NavSignz id="navsignz" className="nav-signz" />
            <NavCareers id="navcareers" className="nav-careers" />
            <NavTeam id="navteam" className="nav-team" />
            <NavCompany id="navcompany" className="nav-company" />
            <NavOptions className="nav-options" />
            <SignzData />
            <CareersData />
            <TeamData />
            <CompanyData />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Fourth;
